jQuery( document ).ready( function( $ ) {
    $( '.slick-slider' ).not('.slick-initialized').each( function () {
        let slidesToShow = $( this ).attr( 'data-slidestoshow' );
        console.log(slidesToShow);
        $(this).slick({
            infinite: true,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed:6000,
            cssEase: 'linear',
            centerMode: true,
            variableWidth:false,
            slidesToShow: parseInt( slidesToShow )
        });
    });
});